import React from "react";
import {Breadcrumb} from "antd";
import "./BreadCrum.scss";
import {Link, useLocation} from "react-router-dom";
const BreadCrum = () => {
  const location = useLocation();
  const pathSnippets = location.pathname.split("/").filter(i => i);
  var functionName = "";
  const breadcrumbNameMap: Record<string, string> = {
    "/tiep-nhan": "Tiếp nhận",
    "/kham-benh": "Khám bệnh ngoại trú",
    "/khuc-xa": "Khúc xạ",
    "/dieu-duong-noi-tru": "Điều trị nội trú",
    "/dieu-tri-noi-tru/dieu-duong-noi-tru": "Điều dưỡng nội trú",
    "/dieu-tri-noi-tru/dieu-tri": "Điều trị",
    "/dieu-tri": "Điều trị",
    "/dieu-duong-noi-tru/phau-thuat": "Phẫu thuật",
    "/dieu-duong/ngoai-tru": "Điều dưỡng ngoại trú",
    "/phau-thuat": "Phẫu thuật",
    "/thanh-toan/thanh-toan": "Thanh toán",
    "/thanh-toan/day-du-lieu-xml": "Đẩy dữ liệu XML",
    "/thanh-toan/ket-xuat-xml": "Kết xuất XML",
    "/duoc-vat-tu": "Dược vật tư",
    "/duoc-vat-tu/nha-thuoc": "Nhà thuốc",
    "/duoc-vat-tu/kho-duoc": "Kho dược",
    "/duoc-vat-tu/kho-vat-tu-y-te": "Kho vật tư y tế",
    "/xet-nghiem": "Xét nghiệm",
    "/chan-doan-hinh-anh": "Chẩn đoán hình ảnh",
    "/he-thong": "Hệ thống",
    "/cskh": "CS khách hàng",
    "/cs-khach-hang/tu-van-dieu-tri": "Tư vấn điều trị",
    "/cskh/cham-soc-khach-hang": "Chăm sóc khách hàng",
    "/kinh": "Kính",
    "/kinh/quay-kinh": "Quầy kính",
    "/kinh/kho-kinh": "Kho kính",
    "/cs-khach-hang": "CS khách hàng",
    "/cs-khach-hang/tu-van-va-dieu-tri": "Tư vấn",
    "/cs-khach-hang/the-kham-va-chuong-trinh-uu-dai":
      "Thẻ khám và chương trình ưu đãi",
    "/cs-khach-hang/cham-soc-khach-hang": "Chăm sóc khách hàng",
    "/quan-ly-dich-vu/dich-vu-ky-thuat": "Dịch vụ kỹ thuật",
    "/quan-ly-dich-vu/goi-dich-vu": "Gói dịch vụ",
    "/he-thong/phan-quyen": "Phân quyền",
    "/he-thong/danh-muc-chung": "Danh mục chung",
    "/dien-tim": "Điện tim",
    "/dieu-tri-noi-tru/phau-thuat": "Phẫu thuật",
    "/quan-ly-nhan-su/danh-sach-nhan-vien": "Danh sách nhân viên",
    // "/quan-ly-nhan-su/khen-thuong":"Khen thưởng",
    "/quan-ly-nhan-su/ky-luat": "Kỷ luật",
    "/quan-ly-nhan-su/cong-chuan-thang": "Công chuẩn tháng",
    "/quan-ly-nhan-su/danh-muc-ung-vien": "Danh mục ứng viên",
    "/quan-ly-nhan-su/khoa-dao-tao": "Khóa đào tạo",
    "/quan-ly-van-ban": "Quản lý văn bản",
    "/quan-ly-nhan-su/dot-tuyen-dung": "Đợt tuyển dụng",
    "/tinh-luong/cham-cong": "Chấm công",
    "/tinh-luong/cham-cong-tho": "Chấm công thô",
    "/tinh-luong/theo-doi-nghi-bu": "Theo dõi nghỉ bù",
    "/tinh-luong/theo-doi-di-muon": "Theo dõi đi muộn",
    "/tinh-luong/dang-ky-nghi-phep": "Đăng ký nghỉ phép",
    "/tinh-luong/cham-cong-lam-them-gio": "Chấm công làm thêm giờ",
    "/tinh-luong/bang-luong": "Bảng lương",
    "/tinh-luong/theo-doi-bhxh": "Theo dõi BHXH",
    "/tinh-luong/cai-dat-luong": "Cài đặt lương",
    "/tinh-luong/bieu-thue": "Biểu thuế TNCN",
    "/tinh-luong/khai-bao-quyen-duyet": "Khai báo quyền duyệt",
    "/tinh-luong/khai-bao-nguoi-duyet": "Khai báo người duyệt",
    "/tinh-luong/danh-muc-trang-thai-duyet": "Danh mục trạng thái duyệt",
    "/tinh-luong/duyet-bang-luong": "Duyệt bảng lương",
    "/tai-chinh-ke-toan/bao-cao-doanh-thu": "Báo cáo doanh thu",
    "/tai-chinh-ke-toan/bao-cao-kho": "Báo cáo kho",
    "/tai-chinh-ke-toan/bao-cao-tong-hop": "Báo cáo tổng hợp",
    "/tinh-luong/ca-lam-viec": "Ca làm việc",
    "/benh-nhan-cu": "Thông tin bệnh nhân cũ",
    "/quan-ly-mua-sam/mua-sam": "Quản lý mua sắm",
    "/quan-ly-mua-sam/thanh-toan": "Quản lý thanh toán",
    // "/ki-bao-mat": "Kí bảo mật",
  };
  const extraBreadcrumbItems = pathSnippets.map((_, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join("/")}`;
    if (index == pathSnippets.length - 1) {
      functionName = breadcrumbNameMap[url];
    }
    return {
      key: url,
      title: <div>{breadcrumbNameMap[url]}</div>,
    };
  });

  return (
    <div className="breadcrum">
      {/* <Breadcrumb items={extraBreadcrumbItems} /> */}
      <div className="function-name">{functionName}</div>
    </div>
  );
};
export default BreadCrum;
